export enum ProcessNotificationSetting {
    None = 0,
    NotifyAppraisee = 1,
    NotifyPm = 2,
    NotifyHr = 4,
    NotifyRespondent = 8
}